// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Loader__wrapper___Ee_fl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader.scss
// module id = 593
// module chunks = 1